/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useT } from 'talkr';
import OnlyOneOption from '../../components/onlyOneOption';
import steps from '../../survey/steps';
import s from './index.module.scss';
import defaultOption from '../styles/defaultOption.module.scss';
import common from '../index.module.scss';
import optionsImages from '../../survey/optionsImages';
import questionsMethods from '../../survey/questions';

function DefaultQuestion(props) {
  const { T } = useT();
  const dispatch = useDispatch();
  const { options, name } = props.step;
  const { withoutDescription } = props;
  const age = questionsMethods.getAnswers({ questionName: 'age' }).value;
  const imgAtRightSide = props.design ? defaultOption.imgAtRightSide : '';

  useEffect(() => {
    name === 'puppy_or_adult' && dispatch({
      type: 'IS_STATUSBAR_TRANSPARENT',
      payload: false,
    });
  });

  function actionOnClick() {
    setTimeout(() => {
      steps.navigate.forward({
        preventAction: 500,
      });
    }, 300);
  }

  function additionalPicture() {
    let imgSrc;
    let isAdditionalPicture = false;
    if (optionsImages.additional_picture[name]) {
      isAdditionalPicture = true;
      imgSrc = optionsImages.additional_picture[name];
    } else {
      isAdditionalPicture = false;
      imgSrc = '';
    }
    return (
      <img
        className={
          isAdditionalPicture
            ? s.additionalPicture_show
            : s.additionalPicture_hide
        }
        src={imgSrc}
        alt=""
      />
    );
  }

  return (
    <section className={`${common.step}`}>
      <div className={common.stepTitle}>{T(name)}</div>
      {!withoutDescription && <div className={common.stepDescription}>{T(`${name}_description`)}</div>}

      {additionalPicture()}

      <div className={s.options}>
        {
          options && Object.entries(options).map((option) => {
            let imgSrc;
            if (optionsImages[name]) imgSrc = (age && age !== 'puppy' && optionsImages[name][age]) ? optionsImages[name][option[1].value] : optionsImages[name][option[1].value];
            const withDescription = option[1].description;
            return (
              <OnlyOneOption
                key={option[1].value}
                className={`${defaultOption.option} ${s.optionWithArrow} ${withDescription ? s.withDescription : ''} ${props.isExpandedDesign} ${imgAtRightSide}`}
                selectedStateClass={s.optionWithArrowSelected}
                option={option[1]}
                questionName={name}
                actionOnClick={actionOnClick}
                disableFromFocus={!props.isThisCurrentStep}
                runOnChoose={() => { steps.userMovedToNextStepByClick({ byNextStep: true }); }}
                design={props.design}
              >
                {imgSrc && (
                  <div className={defaultOption.iconWrapper}>
                    <img className={defaultOption.icon} src={imgSrc} alt="" />
                  </div>
                )}
                {!withDescription && T(`${name}_${option[1].value}`)}
                {withDescription
                  && (
                    <div>
                      <div className={`${option[1].design === 'smallTitleWithDescription' ? '' : s.title}`}>
                        {T(`${name}_${option[1].value}`)}
                        {option[1].design === 'titleWithLabel' ? <div className={s.optionLabel}>{T('frequency_label_recommended')}</div> : ''}
                      </div>
                      <div className={s.description}>{T(`${name}_${option[1].description}`)}</div>
                    </div>
                  )}
              </OnlyOneOption>
            );
          })
        }
      </div>
    </section>
  );
}

function WithOneOption(props) {
  const questions = useSelector((state) => state.questions.list);
  const questionName = props.stepData.name;
  const question = questions[questionName];
  const { isThisCurrentStep } = props;
  const { isCurrentStepCompleted } = props;
  const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
  const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';
  const isExpandedDesign = props.isExpandedDesign ? s.designExpanded : '';
  const config = useSelector((state) => state.steps.config);
  const withoutDescription = config === 'short';

  return (
    <div className={`${s.step} ${isThisCurrentStepClass} ${isThisStepCompletedClass}`}>
      <DefaultQuestion
        design={props.design}
        step={question}
        index={1}
        isThisCurrentStep={isThisCurrentStep}
        isExpandedDesign={isExpandedDesign}
        withoutDescription={withoutDescription}
      />
    </div>
  );
}

export default WithOneOption;
